<a routerLink="/shop/dashboard" class="wishlist-link" title="{{points}} Points">
    <i class="icon-gift"></i>
    <span class="wishlist-count badge"> {{points| number:'1.2-2'}} </span>
    <span class="wishlist-txt">Reward</span>
</a>